import { Dispatch, SetStateAction } from 'react';
import { ProcessQuery } from '../../services/api/dataSource/dataSource.types';

export const enum DataSourceTabs {
  DATA_SOURCE = 'dataSource',
}

export interface ProcessVariable {
  [key: string]: string;
}

export interface DataSourceFormData extends ProcessQuery {
  sqlQuery: string;
  name: string;
  type: 'sql' | 'api';
  val: ProcessVariable[] | string;
  uniqueIdentifier: string;
}

export interface FormErrors {
  [key: string]: string;
}

export interface AddDataSourceModalProps {
  isOpen: boolean;
  closeModal: () => void;
  execFunction: (data: DataSourceFormData) => Promise<void>;
  selectedDataSource?: ISqlQueryObj;
  setSelectedDataSource?: Dispatch<SetStateAction<ISqlQueryObj | undefined>>;
}

export interface DataSourceType {
  id: number;
  name: string;
  type: string;
  dataSourceVariables: [{ key: string }];
  title?: string;
  documentName?: string;
  documentType?: string;
  catalogItems?: Record<string, Array<{ id: number; name: string }>>;
  createdAt: string;
  sqlQuery: string;
  user?: { firstName: string; lastName: string };
  createdBy?: { firstName: string; lastName: string };
}

export type DataItem = {
  key: string;
  value: string;
};
export interface ISqlQueryObj {
  id: number;
  type: 'sql' | 'api';
  name: string;
  sqlQuery: string;
  uniqueIdentifier: string;
  createdAt?: string;
  updatedAt?: string;
  dataSourceVariables?: [{ key: string }];
  user?: { id: number; firstName: string; lastName: string };
  createdBy?: { id: number; firstName: string; lastName: string };
}
